/**
 * Slugify a string into a slugified (dasherized) string
 *
 * @param text number | string
 * @returns string
 */ const slugify = (text)=>{
    return text.toString().normalize('NFD') // split an accented letter in the base letter and the accent
    // eslint-disable-next-line unicorn/prefer-string-replace-all
    .replace(/[\u0300-\u036F]/g, '') // remove all previously split accents
    .toLowerCase().trim() // remove trailing spaces
    // eslint-disable-next-line unicorn/prefer-string-replace-all
    .replace(/\s+/g, '-') // replace spaces with -
    // eslint-disable-next-line unicorn/prefer-string-replace-all
    .replace(/[^\w-]+/g, '') // remove all non-word characters
    // eslint-disable-next-line unicorn/prefer-string-replace-all
    .replace(/_/g, '-') // replace _ with -
    // eslint-disable-next-line unicorn/prefer-string-replace-all
    .replace(/--+/g, '-') // replace multiple - with single -
    // eslint-disable-next-line unicorn/prefer-string-replace-all
    .replace(/-$/g, ''); // remove trailing -
};

export { slugify };
//# sourceMappingURL=slugify.js.map
